import { FishingReport, SeasonGroup, Species, WaterbodyDetail } from '@omniafishing/core';
import { Skeleton } from 'antd';
import React from 'react';
import { MapFishingReportCard } from '../featured_reports_modal/map_fishing_report_card';
import styles from './tab_fishing_reports.less';

interface TabFishingReportsProps {
  waterbody: WaterbodyDetail;
  fishingReports: FishingReport[];
  fishingReportsLoading: boolean;
  selectedSeasonGroup: SeasonGroup;
  selectedSpecies: Species;
  loadMoreElementRef: (node: HTMLDivElement) => void;
}

export const TabFishingReports = (props: TabFishingReportsProps) => {
  const {
    fishingReports,
    fishingReportsLoading,
    waterbody,
    selectedSpecies,
    selectedSeasonGroup,
    loadMoreElementRef,
  } = props;

  const { fishing_reports_count } = waterbody;
  const skeletonCount = Math.min(3, fishing_reports_count);

  const emptyParamsMessage = (() => {
    let message = '';
    if (selectedSeasonGroup || selectedSpecies) {
      message += `for ${[selectedSeasonGroup?.display_name, selectedSpecies?.display_name]
        .filter(Boolean)
        .join(' + ')}`;
    }
    return message;
  })();

  return (
    <div>
      <section className={styles.body}>
        <ol className={styles.fishingReportsList}>
          {fishingReportsLoading ? (
            <>
              {Array.from({ length: skeletonCount }, (__, i) => (
                <Skeleton active key={i} paragraph={{ rows: 4 }} />
              ))}
            </>
          ) : (
            <>
              {fishingReports.length > 0 ? (
                <>
                  {fishingReports.map((fishingReport) => {
                    return (
                      <li key={fishingReport.id} className={styles.fishingReportsItem}>
                        {/* fetch more when reaching the 2nd to last item */}
                        {fishingReports.indexOf(fishingReport) === fishingReports.length - 2 && (
                          <div ref={loadMoreElementRef} />
                        )}
                        <MapFishingReportCard
                          report={fishingReport}
                          showLakeName={false}
                          wideView
                        />
                      </li>
                    );
                  })}
                </>
              ) : (
                <li>
                  {waterbody.primary_name} has no fishing reports {emptyParamsMessage}
                </li>
              )}
            </>
          )}
        </ol>
      </section>
    </div>
  );
};
